<highcharts-chart 
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  [oneToOne]=true
  [(update)]="updateFlag"

  style="width: 100%; height: 160px; display: block;"
></highcharts-chart>